import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchContent } from "@/lib/api";
import { FadeUp, RevealImage } from "@/components/Reveal";
import { KanthaStitch } from "@/components/Motifs";

export default function Collections() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent("/collections")
      .then(setCollections)
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="collections-page" className="pt-24">
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-16">
        <FadeUp>
          <p className="text-[11px] tracking-[0.3em] uppercase text-alta mb-6">The Archive</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight text-ink">Collections</h1>
          <p className="mt-6 max-w-xl text-base font-light text-ink/65 leading-relaxed">
            Each collection is an exhibition chapter — a Bengali idea carried from sketchbook to silhouette.
          </p>
        </FadeUp>
      </section>

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 pb-28">
        {loading ? (
          <p className="text-ink/50 font-light" data-testid="collections-loading">Unrolling the archive…</p>
        ) : (
          <div className="space-y-24 md:space-y-32">
            {collections.map((col, i) => (
              <FadeUp key={col.id}>
                <Link
                  to={`/collections/${col.slug}`}
                  data-testid={`archive-card-${col.slug}`}
                  data-cursor="EXPLORE"
                  className="group grid grid-cols-1 md:grid-cols-12 gap-8 items-center"
                >
                  <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                    <RevealImage src={col.hero_image} alt={col.title} className="aspect-[16/10]" />
                  </div>
                  <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-1 md:text-right" : ""}`}>
                    <p className="text-[11px] tracking-[0.3em] uppercase text-terracotta mb-4">
                      Chapter {String(i + 1).padStart(2, "0")} — {col.year}
                    </p>
                    <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-wide text-ink group-hover:text-alta transition-colors duration-500">
                      {col.title}
                    </h2>
                    <p className={`mt-5 text-base font-light text-ink/65 leading-relaxed max-w-md ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
                      {col.concept}
                    </p>
                    <p className="link-underline inline-block mt-8 text-[11px] font-medium tracking-[0.25em] uppercase text-ink">
                      View Collection
                    </p>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        )}
        <KanthaStitch className="mt-24" />
      </section>
    </main>
  );
}
